/**
 * Global Fetch Interceptor
 *
 * Wraps globalThis.fetch to prepend the remote API base URL
 * to any request targeting the sych.local backend.
 *
 * Works in both main thread and Web Workers.
 *
 * Intercepted path prefixes:
 * - /api/   (media API, video meta, map tiles)
 * - /rec/   (video files, thumbnails)
 * - /osd/   (OSD WASM, config, resources)
 */

const API_PATH_PREFIXES = ['/api/', '/rec/', '/osd/'];

/**
 * Install the fetch interceptor in the current context.
 * Must be called before any API calls are made.
 *
 * @param apiBase - Full origin to prepend (e.g., "https://sych.local")
 */
export function installFetchInterceptor(apiBase: string): void {
  const originalFetch = globalThis.fetch;

  globalThis.fetch = function interceptedFetch(
    input: RequestInfo | URL,
    init?: RequestInit,
  ): Promise<Response> {
    if (typeof input === 'string') {
      for (const prefix of API_PATH_PREFIXES) {
        if (input.startsWith(prefix)) {
          return originalFetch.call(globalThis, `${apiBase}${input}`, init);
        }
      }
    }
    return originalFetch.call(globalThis, input, init);
  } as typeof fetch;
}
